<template>
    <div>
        <wp_card style="margin-top: 10px; box-shadow: 1px 1px 5px #909090">
            <div slot="head"></div>
            <van-row style="padding-left: 5px">
                <van-col span="10">
                    <h2>本月预估收入:</h2>
                </van-col>
                <van-col span="14">
                    <h2><span style="color: red">￥{{monthCountData.efeetoday.toFixed(2)}}</span></h2>
                </van-col>
            </van-row>

        </wp_card>

        <div v-if="$common.getLimitPayTime().canPay" style="padding: 10px; margin-top: 10px">
            <van-button type="danger" size="large" @click="payDataDetail">提 款</van-button>
        </div>

        <wp_card style="margin-top: 10px; box-shadow: 1px 2px 5px #909090">
            <div slot="head">
                <van-cell-group>
                    <van-cell :title="title" style="padding-left: 5px; padding-right: 0px">
                        <h3 slot="title">{{title}}</h3>
                        <template slot="right-icon">
                            <Wp_date_select @onDateSelect="selectDateCount" :default="1"></Wp_date_select>
                        </template>
                    </van-cell>
                </van-cell-group>
            </div>

            <div style="margin-left: 10px">
                商品总额：￥{{countData.epricetoday.toFixed(2)}}

            </div>
            <div style="margin-left: 10px">
                预估收入：￥{{countData.efeetoday.toFixed(2)}}
            </div>
            <div style="margin-left: 10px">
                订单总数：{{orderCount}}
            </div>
            <van-divider :style="{borderColor: '#cccccc',  'margin-left': '-10px', 'margin-right': '-10px'}"/>

            <Wp_chart_line :pid="pid"
                           :start_time="startTime"
                           :end_time="endTime"
                           style="margin-top: 20px"
                           v-on:setOrderCount="getOrderCount"
            ></Wp_chart_line>
        </wp_card>
    </div>
</template>

<script>
    import Wp_date_select from "@/components/custom/Wp_date_select";
    import Wp_chart_line from "../custom/Wp_chart_line";
    import wp_card from "../waps_ui/wp_card";
    export default {
        name: "Wp_order_count",
        components: {wp_card, Wp_chart_line, Wp_date_select},
        props: {
            pid: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                active: '1',
                title:'今日数据',
                startTime:this.$store.state.startTime,
                endTime:this.$store.state.endTime,
                countData: {
                    code: 200,
                    efeed18: 0, //当天已结算金额
                    efeem18: 0,  //本月已结算金额
                    efeemonth: 0,  //本月预估收入
                    efeetoday: 0, //当天预估收入
                    epricemonth: 0,  //本月商品总额
                    epricetoday: 0,  //当天商品总额
                    msg: "sucess",
                },

                monthCountData: {
                    code: 200,
                    efeed18: 0, //当天已结算金额
                    efeem18: 0,  //本月已结算金额
                    efeemonth: 0,  //本月预估收入
                    efeetoday: 0, //当天预估收入
                    epricemonth: 0,  //本月商品总额
                    epricetoday: 0,  //当天商品总额
                    msg: "sucess",
                },

                orderCount : 0,
            }
        },
        created() {
        },
        mounted(){
            this.getMonthCount();
        },
        methods: {
            /**
             * 提款
             */
            payDataDetail(){
                // if(this.$store.state.userPhone && this.$store.state.userPhone !== "0"){
                //     this.$router.push('paydata');
                // }else{
                //     this.$dialog.confirm({
                //         message: "请绑定手机号",
                //     }).then(()=>{
                //         this.$router.push("update_phone");
                //     }).catch(()=>{
                //
                //     })
                // }
                this.$common.pay_from_data_page = true;
                this.$router.push('my');
            },

            getMonthCount() {
                let currentDate = new Date();
                let year = currentDate.getFullYear();
                let month = currentDate.getMonth();
                let start_time = this.$common.dateFmt("yyyy-MM-dd", new Date(year, month, "1"));
                let end_time = this.$common.dateFmt("yyyy-MM-dd", currentDate);

                let _data = {
                    pid: this.$common.getPid(),
                    stime: start_time,
                    etime: end_time,
                };
                this.$log(_data);
                let that = this;
                this.$getOrderCountByData(_data, function (response) {
                    that.monthCountData = response;
                    that.$log(response);
                })
            },

            showTitle(){
               let testTime_1=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
               let testTime_2=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', -1, new Date()));
               if(testTime_1===this.startTime && testTime_1===this.endTime){
                   this.title='今日数据'
               }else  if(testTime_2===this.startTime && testTime_2===this.endTime){
                   this.title='昨日数据'
               }else if(this.startTime===this.endTime){
                   this.title='数据('+this.startTime+')'
               }else{
                   this.title=this.startTime+' 至 '+this.endTime+' 数据'
               }
            },
            getOrderCountBy() {
                let _data = {
                    pid: this.$common.getPid(),
                    stime: this.startTime,
                    etime: this.endTime,
                };
                this.$log(_data);
                let that = this;
                this.$getOrderCountByData(_data, function (response) {
                    that.countData = response;
                    that.$log(response);
                })
            },
            selectDateCount(selectDate) {
                this.$log(selectDate);
                this.startTime = selectDate.startTime;
                this.endTime = selectDate.endTime;
                this.getOrderCountBy();
                this.showTitle();
            },

            getOrderCount(count){
                this.orderCount = count;
                this.$log("this.orderCount = " + this.orderCount);
            }
        }
    }
</script>

<style scoped>

</style>
